import {
    ObtieneDocumentoPorAlumno,
    ObtieneDatosFacturacion,
    ObtieneDatosPersonales,
    GrabarFacturacion,
    Get_FacturacionInfoMatricula,
    Del_FacturacionInfoMatricula
} from "../../../application/interactors/Facturacion";

export const ObtieneDocumentoPorAlumnoLogic = (selListaDocumentoFacturacion: any, headers: any, rut: number, codigoNegocio: number,
    codigoPrograma: string, codigoPlanificacion: number, agno: number, periodo: number, idPeriodo: number) => {
    return ObtieneDocumentoPorAlumno(selListaDocumentoFacturacion, headers, rut, codigoNegocio, codigoPrograma,
        codigoPlanificacion, agno, periodo, idPeriodo);
}

export const ObtieneDatosFacturacionLogic = (
    selCargarDatosFacturacion: any,
    headers: any,
    RutFacturacion: string

) => {
    return ObtieneDatosFacturacion(
        selCargarDatosFacturacion,
        headers,
        RutFacturacion
    );
};

export const ObtieneDatosPersonalesLogic = (
    selCargarDatosPersonales: any,
    RutFacturacion: string,
    headers: any
) => {
    return ObtieneDatosPersonales(
        selCargarDatosPersonales,
        RutFacturacion, headers
    );
};

//Datos Facturacion

export const GrabarFacturacionLogic = (
    selGrabarDatosFacturacion: any,
    IdProcesoPostulante: number,
    RutFacturacionSF: number,
    DV: string,
    Giro: string,
    RazonSocial: string,
    CorreoFacturacion: string,
    Telefono: string,
    Direccion: string,
    IDComuna: number,
    DatosAlumno: boolean

) => {
    return GrabarFacturacion(
        selGrabarDatosFacturacion,
        IdProcesoPostulante,
        RutFacturacionSF,
        DV,
        Giro,
        RazonSocial,
        CorreoFacturacion,
        Telefono,
        Direccion,
        IDComuna,
        DatosAlumno
    );
};

export const GetFacturacionInfoMatriculaLogic = (
    SelGetFacturacionInfoMatricula: any,
    IdProcesoPostulante: number,
    RutFacturacion: number

) => {
    return Get_FacturacionInfoMatricula(
        SelGetFacturacionInfoMatricula,
        IdProcesoPostulante,
        RutFacturacion
    );
};



export const Del_FacturacionInfoMatriculaLogic = (
    SelDelFacturacionInfoMatricula: any,
    IdProcesoPostulante: number

) => {
    return Del_FacturacionInfoMatricula(
        SelDelFacturacionInfoMatricula,
        IdProcesoPostulante
    );
};
